import BaseImg from './BaseImg.vue'

export default BaseImg
